import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "more",
  "use": "more-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"more\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 11.556a1.778 1.778 0 100 3.555 1.778 1.778 0 000-3.555zm0-5.334a1.778 1.778 0 100 3.556 1.778 1.778 0 000-3.556zM6.222 2.667a1.778 1.778 0 113.556 0 1.778 1.778 0 01-3.556 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol